//通用
import { Data as AuthContent } from '../authentication/index'
import { Data as ChangeLogContent } from '../changelog/index'



import Introduce from './1_introduce.json'
import { Data as AccountContent } from './api/account/index'
import { Data as WalletContent } from './api/wallet/index'
import { Data as TradeOrderContent } from './api/trade/index'
import { Data as MarketContent } from './api/market/index'
import { Data as BasicContent } from './api/basic/index'
import { List as SocketContent } from './websocket/index'


import { Data as QandAContent } from '../q&a/index'
const QandA = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/q&a`,
  "name": "Frequently Asked Questions",
  "content": QandAContent
}

const ROOT_MODULE = "en-us/spot"

export const Socket = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/socket`,
  "name": "Socket API Reference",
  "children": SocketContent
}


const ChangeLog = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/changelog`,
  "name": "Change Log",
  "content": ChangeLogContent
}
const TradeOrder = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/trade-api.html`,
  "name": "Trades Endpoints",
  "content": TradeOrderContent
}
const Authentication = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication.html`,
  "name": "Authentication",
  "content": AuthContent
}
const Basic = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/base-info.html`,
  "name": "General Info",
  "content": BasicContent
}
const Account = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/account-api.html`,
  "name": "Account assets",
  "content": AccountContent
}
const Wallet = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/wallet-api.html`,
  "name": "Wallet deposits and withdrawals",
  "content": WalletContent
}
const Market = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/market-api.html`,
  "name": "Market Data",
  "content": MarketContent
}


export const spotConfig = [
  Introduce,
  ChangeLog,
  QandA,
  Basic,
  Authentication,
  Market,
  Wallet,
  Account,
  TradeOrder,
  // Other,
  Socket,
]


// WEBPACK FOOTER //
// ./src/config/en-US/spot/index.js